import api from '../../api/'
const state = {
    all:[],
    solde_planning:'',
    horaires:[]
}

const getters= {
    rows(state){
        let data = []
        let row = {
            title: "",
            start: "",
            color: '',
            end: ""
        }
        state.all.forEach(element => {  
            console.log('mon element :',element) 
            let color=""
            var q = new Date();
            var m = q.getMonth();
            var d = q.getDate();
            var y = q.getFullYear();
            var date = new Date(y, m, d);
            let mydate = new Date(element.date);  
            console.log("date du jour ", date)
            console.log("mydate ", mydate)
            if (mydate<date){
                color = 'grey'
            } else if (mydate>=date){
                color=''
            }    
            row = {
                title: element.user.name + " : " + element.guichet.agence.nom_agence+ " - " +element.guichet.nom,
                start: element.date+"T"+element.heure_debut,
                color: color,
                end: element.date + "T" + element.heure_fin
            }
            data.push(row)
        });
        return data;
    },
    solde_planning(state){
        let solde = state.solde_planning
        return solde;
    },
    rows_horaires(state){
        var weekday = new Array(7);
        weekday[0] = "Dimanche";
        weekday[1] = "Lundi";
        weekday[2] = "Mardi";
        weekday[3] = "Mercredi";
        weekday[4] = "Jeudi";
        weekday[5] = "Vendredi";
        weekday[6] = "Samedi";
        let data = []
        let row = {
            jour:"",
            ouvert:"",
            heure_ouverture:"",
            heure_fermeture:""
        }
        state.horaires.forEach(element=>{
            row ={
                jour: weekday[element.jour_semaine],
                ouvert: element.ouvert ? "Ouvert" : "Fermé",
                heure_ouverture: element.heure_ouverture === null ? "--" : element.heure_ouverture,
                heure_fermeture: element.heure_fermeture === null ? "--" : element.heure_fermeture,
            }
            data.push(row)
        });
        return data;
    }

}
const mutations= {
    setPlannings(state, plannings) {
        state.all = plannings
    },
    setHoraires(state, plannings) {
        state.horaires = plannings
    },
    setSoldePlanning(state, solde_planning) {
        console.log("solde_planning ")
        state.solde_planning = solde_planning
    },
    addPlanning(state, planning) {
        state.all.push(planning)
    }
}

const actions={
    get_all_planning({ commit }){
        return api.planning.get_all_planning().then((response)=>{
            console.log('mes plannings ', response.data.data)
            commit('setPlannings', response.data.data)
            return response.data.data
        })
    },
    get_all_planning_by_guichet({ commit },guichet_id){
        return api.planning.get_all_planning_by_guichet(guichet_id).then((response)=>{
            console.log('mes plannings g', response.data.data.data)
            commit('setPlannings', response.data.data.data)
            return response.data.data.data
        })
    },
    get_solde_planning({ commit }){
        return api.planning.get_solde_planning().then((response)=>{
            console.log('mon solde', response.data.data.data)
            commit('setSoldePlanning', response.data.data.data)
            return response.data.data.data
        })
    },
    get_all_planning_by_user({ commit },user_id){
        return api.planning.get_all_planning_by_user(user_id).then((response)=>{
            commit('setPlannings', response.data.data.data)
            return response.data.data.data
        })
    },
    get_all_planning_by_entite({ commit }, entite_id){
        return api.planning.get_all_planning_by_entite(entite_id).then((response)=>{
            //console.log("mes datas horaires :",response.data.data)
            commit('setHoraires', response.data.data)
            return response.data
        })
        .catch(error => {
            return error.response.data
        })
    },
    post_planning({commit},planning){
        return api.planning.post_planning(planning).then((response)=>{
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    post_horaire({commit},planning){
        return api.planning.post_horaire(planning).then((response)=>{
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    put_horaire({commit},planning){
        Object.assign(planning,{_method:'PUT'})
        return api.planning.put_horaire(planning).then((response)=>{
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
